import axiosService from '@/api/common/adminAxios'

const api = {
  mapSysMngList: function(paramData) {
    return axiosService.post('admin/selectMapSysMng', paramData)
  },

  saveMapSysMng: function(paramData) {
    return axiosService.post('admin/saveMapSysMng', paramData)
  },

  deleteMapSysMng: function(paramData) {
    return axiosService.post('admin/deleteMapSysMng', paramData)
  },

  mapItmMngList: function(paramData) {
    return axiosService.post('admin/selectMapItmMng', paramData)
  },

  saveMapItmMng: function(paramData) {
    return axiosService.post('admin/saveMapItmMng', paramData)
  },

  deleteMapItmMng: function(paramData) {
    return axiosService.post('admin/deleteMapItmMng', paramData)
  },

}

export default api
